import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const PauseIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 3.450195 0.999755 L 3.450195 0.999755 C 3.864408 0.999755 4.200195 1.335542 4.200195 1.749755 L 4.200195 8.249755 C 4.200195 8.663968 3.864408 8.999755 3.450195 8.999755 L 3.450195 8.999755 C 3.035981 8.999755 2.700195 8.663968 2.700195 8.249755 L 2.700195 1.749755 C 2.700195 1.335542 3.035981 0.999755 3.450195 0.999755 Z" />
            <path d="M 6.4502 0.999755 L 6.4502 0.999755 C 6.864414 0.999755 7.2002 1.335542 7.2002 1.749755 L 7.2002 8.249755 C 7.2002 8.663968 6.864414 8.999755 6.4502 8.999755 L 6.4502 8.999755 C 6.035986 8.999755 5.7002 8.663968 5.7002 8.249755 L 5.7002 1.749755 C 5.7002 1.335542 6.035986 0.999755 6.4502 0.999755 Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const PauseIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 3.450195 0.999755 L 3.450195 0.999755 C 3.864408 0.999755 4.200195 1.335542 4.200195 1.749755 L 4.200195 8.249755 C 4.200195 8.663968 3.864408 8.999755 3.450195 8.999755 L 3.450195 8.999755 C 3.035981 8.999755 2.700195 8.663968 2.700195 8.249755 L 2.700195 1.749755 C 2.700195 1.335542 3.035981 0.999755 3.450195 0.999755 Z" />
            <path d="M 6.4502 0.999755 L 6.4502 0.999755 C 6.864414 0.999755 7.2002 1.335542 7.2002 1.749755 L 7.2002 8.249755 C 7.2002 8.663968 6.864414 8.999755 6.4502 8.999755 L 6.4502 8.999755 C 6.035986 8.999755 5.7002 8.663968 5.7002 8.249755 L 5.7002 1.749755 C 5.7002 1.335542 6.035986 0.999755 6.4502 0.999755 Z" />
        </SvgIcon>
    );
};
